import { observer } from 'mobx-react';
import PromobannerName from '../../../../components/PromobannerName/PromobannerName';
import { PromobannerTarget } from '../../../../components/PromobannerTarget/PromobannnerTarget';
import PromobannerUpload from '../../../../components/PromobannerUpload/PromobannerUpload';
import PromobannerValidity from '../../../../components/PromobannerValidity/PromobannerValidity';
import { defaultPromobanner } from '../../../../constants/promobanners';
import { promobannerStore } from '../../../../store/promobannerStore';
import PromobannerEditLoader from '../PromobannerEditLoader/PromobannerEditLoader';
import PromoBannerOfferToggle from '../../../../components/PromoBannerOfferToggle/PromoBannerOfferToggle';

const PromoBannerEditContent = observer((): JSX.Element | null => {
  if (JSON.stringify(promobannerStore.promobanner) === JSON.stringify(defaultPromobanner) && promobannerStore.loading)
    return <PromobannerEditLoader />;

  return (
    <>
      <PromobannerUpload />
      <div className="promobanner-row">
        <PromobannerName />
        <PromobannerValidity />
        <PromoBannerOfferToggle />
      </div>
      <PromobannerTarget />
    </>
  );
});

export default PromoBannerEditContent;
